var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDuplicateDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3546_6376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3636 15.1624H13.2967V16.2293H4.49465V5.29347H5.56156V4.22656H3.42773V17.2962H14.3636V15.1624Z",
    fill: "#8F96A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62695 1.29297V14.0959H17.2961V5.87312L12.7159 1.29297H6.62695ZM16.2292 13.029H7.69386V2.35988H11.1613V7.42771H16.2292V13.029ZM16.2292 6.3608H12.2282V2.35988H12.274L16.2292 6.31502V6.3608Z",
    fill: "#8F96A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3546_6376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.0706,
    height: 17.0706,
    fill: "white",
    transform: "translate(0.759766 0.759766)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateDark);
export default __webpack_public_path__ + "static/media/duplicate-dark.4c13a0f0e2ef531082f2d0d1621fe755.svg";
export { ForwardRef as ReactComponent };